import { useInternalAccessCheck } from '../features/account/hooks/roleHooks'
import utilsService from '../services/UtilsService'

export enum ExperimentalFeature {
  LiveEventMotivations = 'liveEventMotivations',
  LiveEventAICustomPrompt = 'liveEventAICustomPrompt',
}

export const useDisplayExperimentalFeature = (experimentalFeature: ExperimentalFeature) => {
  const internalUser = useInternalAccessCheck()

  switch (experimentalFeature) {
    case ExperimentalFeature.LiveEventMotivations:
      return internalUser

    case ExperimentalFeature.LiveEventAICustomPrompt: // NOTE: This most likely will stay Internal only feature forever
      return utilsService.getEnvironmentType() !== 'prod' && internalUser

    default:
      return false
  }
}
